import { useEffect, useState } from "react";
import React from "react";

import './BottomStatusBar.css'

export function BottomStatusBar(props) {
    let [coordinate, setCoordinate] = useState({ x: 0, y: 0, z: 0 });
    //let newepsg = 4326;
    //let digits = 2;
    let [newepsg, setNewepsg] = useState(4326);
    let [digits, setDigits] = useState(2);
    let [scale, setScale] = useState(0);

    const engine = window.GetEPSGEngine();

    useEffect(() => {
        let mapDiv = document.getElementById("MainMap");
        mapDiv.onmousemove = () => {
            let mousePos = window.gMainMap.TerrainView.mousePos;
            if (mousePos !== null) {
                setCoordinate({
                    x: mousePos.x,
                    y: mousePos.y,
                    z: mousePos.z
                })

                getScaleRuler();
            }
        };
        return (() => {
            mapDiv.onmousemove = null;
        });
    }, []);

    function getScaleRuler() {
        let mapDiv = document.getElementById("MainMap");
        let centerW = mapDiv.getElementsByTagName("canvas")[0].width / 2;
        let centerH = mapDiv.getElementsByTagName("canvas")[0].height / 2;

        let dpi = js_getDPI();

        let p1 = new window.GeoPoint(centerW, centerH);
        let p2 = new window.GeoPoint(centerW + dpi[0] / (2.54), centerH);//1inch = 2.54cm
        window.gMainMap.TerrainView.windowToTerrain(p1);
        window.gMainMap.TerrainView.windowToTerrain(p2);

        engine.Transfer(4326, 3857, p1);
        engine.Transfer(4326, 3857, p2);

        let newScale = Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2)) * 100;
        setScale(newScale);
    }

    //取得dpi
    function js_getDPI() {
        var arrDPI = [];
        if (window.screen.deviceXDPI !== undefined) {
            arrDPI[0] = window.screen.deviceXDPI;
            arrDPI[1] = window.screen.deviceYDPI;
        }
        else {
            var tmpNode = document.createElement("MainMap");
            tmpNode.style.cssText = "width:1in;height:1in;position:absolute;left:0px;top:0px;z-index:99;visibility:hidden";
            document.body.appendChild(tmpNode);
            arrDPI[0] = parseInt(tmpNode.offsetWidth);
            arrDPI[1] = parseInt(tmpNode.offsetHeight);
            tmpNode.parentNode.removeChild(tmpNode);
        }
        return arrDPI;
    }

    function financial(arg, digits) {
        return Number.parseFloat(arg).toFixed(digits);
    }

    function epsgTransform(x, y, newepsg) {
        var epsgEngine = new window.CEPSGEngine();
        epsgEngine.Init();
        var transferClient = epsgEngine.GenerateClient(4326, newepsg);

        var point = new window.GeoPoint(x, y);
        transferClient.Transfer(point);
        return point;
    }

     function selectEPSGOnChange(e) {
         console.log(e);
         switch (e) {
             default:
             case '經緯度':
                 setNewepsg(4326);
                 setDigits(2);
                 break;
             case 'TWD97':
                 setNewepsg(3826);
                 setDigits(2);
                 break;
             case 'TWD67':
                 setNewepsg(3828);
                 setDigits(2);
                 break;            
         }
     }

    return (
        <div className='bottomStatusBar'>
            <span className='data'>
                【比例(公分):1:{scale}】
            </span>
            {<select id="epsg" onChange={(e) => { selectEPSGOnChange(e.target.value) }}>
                <option value="經緯度">經緯度</option>
                <option value="TWD97">TWD97</option>
                {/*<option value="TWD67">TWD67</option>*/}
            </select>}
            <div className='coordinates'>
                <span className="coordinates__headtext">
                    【坐標:
                </span>
                <span className="coordinates__xtext" id="x_coordinates">
                    X:{financial(epsgTransform(coordinate.x, coordinate.y, newepsg).x, digits)},
                </span>
                <span className="coordinates__ytext" id="y_coordinates">
                    Y:{financial(epsgTransform(coordinate.x, coordinate.y, newepsg).y, digits)},
                </span>
                <span className="coordinates__htext" id="h_coordinates">
                    高度:{financial(coordinate.z, 2)}(m)
                </span>
                <span className="coordinates__tailtext">
                    】
                </span>
            </div>
        </div>
    );
}